module.exports = __webpack_public_path__ + "static/media/GCR Aviation.d41d8cd9.title";